import {
  ILeagueConfig,
  ITeamConfig,
} from 'fitbeat.models';
import React from 'react';
import ReactTable from 'react-table';
import { MemberTableHeader } from '../../../members/components/memberTableHeader';

interface ITeamTableProps {
  teams: ITeamConfig[];
  leagues: ILeagueConfig[];
  enableLeagues: boolean;
  selectedTeamIndex: number | null;
  onSelectTeam: (index: number) => void;
}

const TeamTable: React.FC<ITeamTableProps> = ({
  teams,
  leagues,
  enableLeagues,
  selectedTeamIndex,
  onSelectTeam,
}) => {
  const getLeagueDisplayName = (leagueId?: string) => {
    if (!leagueId) {
      return '-';
    }
    const league = leagues.find((l) => l.id === leagueId);
    return league ? league.displayName : leagueId;
  };

  const columns = [
    {
      Header: () => <MemberTableHeader header='ID' />,
      accessor: 'id',
      minWidth: 150,
      Cell: (row: { value?: string }) => row.value ?? '-',
    },
    {
      Header: () => <MemberTableHeader header='Team Name' />,
      accessor: 'name',
      minWidth: 150,
    },
    ...(enableLeagues ? [
      {
        Header: () => <MemberTableHeader header='League' />,
        id: 'league',
        accessor: (team: ITeamConfig) => getLeagueDisplayName(team.league),
        minWidth: 150,
      },
    ] : []),
    {
      Header: () => <MemberTableHeader header='Group Link' />,
      id: 'groupLink',
      accessor: (team: ITeamConfig) => team.groupLink,
      minWidth: 150,
    },
    {
      Header: () => <MemberTableHeader header='Target size' />,
      accessor: 'size',
      minWidth: 80,
      Cell: (row: { value?: number }) => row.value ?? '-',
    },
  ];

  return (
    <div className='leaderboards-table'>
      <ReactTable
        className='clickable-row'
        minRows={0}
        resizable
        filterable
        data={teams}
        showPagination={false}
        defaultPageSize={1000}
        loadingText='Loading...'
        noDataText='No teams configured'
        columns={columns}
        getTrGroupProps={(state: any, rowInfo: any) => {
          if (!rowInfo) {
            return {};
          }
          const index = teams.indexOf(rowInfo.original);
          return {
            onClick: () => {
              if (index !== -1) {
                onSelectTeam(index);
              }
            },
            className: index === selectedTeamIndex ? 'selected-config-row' : '',
          };
        }}
      />
    </div>
  );
};

export default TeamTable;
